module.exports = __webpack_public_path__ + "img/welcome-5.9b11d15f.png";